import { render, staticRenderFns } from "./organization-risk-decision-view.vue?vue&type=template&id=f1d7e2de&scoped=true"
import script from "./organization-risk-decision-view.vue?vue&type=script&lang=js"
export * from "./organization-risk-decision-view.vue?vue&type=script&lang=js"
import style0 from "./organization-risk-decision-view.vue?vue&type=style&index=0&id=f1d7e2de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d7e2de",
  null
  
)

export default component.exports